import styled from "styled-components";
import { Link } from "react-router-dom";

export const RegisterMain = styled.div`
  padding: 4rem calc((100vw - 1000px) / 2);

  img {
    position: absolute;
    top: 1.5%;
    left: 3.8%;
    width: 200px;
    height: 70px;
    cursor: pointer;
  }
  @media only screen and (max-width: 991px) {
    img {
      position: absolute;
      top: 1.5%;
      left: 50%;
      transform: translateX(-50%);
    }
  }
`;

export const RegisterHead = styled.div`
  h2 {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 1rem;
    color: rgb(32, 32, 79);
  }
  @media only screen and (max-width: 991px) {
    h2 {
      font-size: 26px;
    }
  }
`;

export const RegisterCard = styled.div`
  background-color: #fff;
  width: 500px;
  margin: auto;
  padding: 20px 30px;
  border-radius: 8px;

  @media only screen and (max-width: 991px) {
    width: 500px;
    padding: 20px 15px;
  }
  @media only screen and (max-width: 820px) {
    width: 500px;
    padding: 20px 15px;
  }
  @media only screen and (max-width: 414px) {
    width: 400px;
  }
  @media only screen and (max-width: 393px) {
    width: 365px;
  }
  @media only screen and (max-width: 380px) {
    width: 350px;
  }
`;

export const SigninToggle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;

  a {
    font-size: 18px;
    font-weight: 500;
    padding: 10px 75px;
    text-transform: uppercase;
  }
  .borderBottom {
    color: #20204f;
    border-bottom: 2px solid lightgray;
  }
  .activeBorder {
    color: #3aaa35;
    border-bottom: 2px solid #3aaa35;
  }
  @media only screen and (max-width: 991px) {
    a {
      font-size: 15px;
      font-weight: 500;
      padding: 10px 62px;
    }
  }
`;

export const RememberMe = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0px;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
    font-weight: 500;
    color: #20204f;

    input {
      margin-right: 5px;
    }
    a {
      color: #3aaa35;
    }
  }
`;

export const RegisterDiv = styled.form`
  .none {
    display: none;
  }
  .block {
    display: block;
  }
  .mbForm {
    margin-bottom: 0.7rem;
  }
  .formDiv {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    margin-bottom: 0.7rem;

    label {
      font-size: 15px;
      font-weight: 500;
      margin-bottom: 5px;
      color: #20204f;
    }
    input {
      width: 100%;
      border: none;
      outline: none;
      border: 2px solid #3aaa35;
      padding: 7px 10px;
      border-radius: 5px;
      font-size: 15px;
      font-weight: 500;
      color: #20204f;
    }
    textarea {
      width: 100%;
      height: 100px;
      border: none;
      outline: none;
      border: 2px solid #3aaa35;
      padding: 7px 10px;
      border-radius: 5px;
      font-size: 15px;
      font-weight: 500;
      color: #20204f;
    }
  }
  p {
    font-size: 16px;
    font-weight: 500;
    font-style: italic;
    color: #20204f;
    margin-bottom: 15px;
    margin-top: 15px;

    a {
      color: #3aaa35;
    }
  }
  h5 {
    font-size: 16px;
    font-weight: 500;
    font-style: italic;
    color: #20204f;
    margin-bottom: 15px;

    input {
      margin-right: 5px;
    }
  }
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    padding: 7px 15px;
    width: 100%;
    border: none;
    outline: none;
    background-color: #3aaa35;
    color: #fff;
    border-radius: 5px;
    font-size: 18px;
    font-weight: 500;
    cursor: pointer;
  }
`;
